export var makeDropdownOnChangeEventObject=function(_ref){var value=_ref.value;return{target:{id:_ref.id,name:_ref.name,value:value}}};